"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBox = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var status_1 = require("utils/constants/status");
var StatusBox = function (props) { return (React.createElement(sok_ui_1.RequestStatusBox, { status: props.status.value, statusList: status_1.STATUS_LIST },
    (0, translation_1.getLocalization)("".concat(props.prefix, "/fetching")),
    (0, translation_1.getLocalization)("".concat(props.prefix, "/fetched")),
    (0, translation_1.getLocalization)("".concat(props.prefix, "/failed")))); };
exports.StatusBox = StatusBox;
